import { render, staticRenderFns } from "./JourneyDaySelectItem.vue?vue&type=template&id=884cea82&scoped=true"
import script from "./JourneyDaySelectItem.vue?vue&type=script&lang=js"
export * from "./JourneyDaySelectItem.vue?vue&type=script&lang=js"
import style0 from "./JourneyDaySelectItem.vue?vue&type=style&index=0&id=884cea82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884cea82",
  null
  
)

export default component.exports